export const PageFeatureFlags = {
  ShowCanadaPostBanner: 'show-canada-post-banner',
} as const;
